import { TStepResult } from "@ancademy/vse-share";
import { SubNamespace } from "./config";

export enum Role {
  seller,
  buyer,
}

export interface ISubCreateParams {
  r: number;
  searchCost: number;
  practice: boolean;
  recall: boolean;
  showIntro: boolean;
  showTest: boolean;
  buyInsurance_secondLimit: number;
  stepInfo?: {
    resultId: string;
    behaviorScore: number;
    questionScore: number;
    stepResult: Omit<TStepResult, "score" | "startTime" | "endTime">;
    stepAmount: number;
  };
}

export enum SubMoveType {
  submitResult,
  toStep,
  answerTest,
  over,
  bargain_setRole,
  bargain_setPrice,
  bargain_ensureBuyerRecord,
  bargain_trade,
  bargain_chat,
  bargain_chatTrade,
  bargain_calcBuyerScore,
  bargain_close,
  bargain_left,
}

export enum SaleX {
  Buy,
  BuyNow,
  BuyLater,
  BuyFull,
  BuyDeposit,
  BuyDeposit_O,
  BuyFull_O,
  DepositBuy,
  Deposit,
  NoBuy,
}

export type TResult = { score: number } & Partial<{
  tradeIndex: number;
  seenList: boolean[];
  depositedList: boolean[];
  p1: number;
  p2: number;
  op1: number;
  op2: number;
  saleXList: SaleX[];
}>;

export enum SubPushType {
  bargain_newShop,
  bargain_newChat,
}

type TAnswers = (number | string)[][];

export type ISubMoveParams = {
  result: TResult;
  answers: TAnswers;
  answerScores: number[];
} & {
  role: Role;
  itemIndex: number;
  chat: TChat;
  buyerIndex: number;
  chatIndex: number;
  sale_P1: number;
};

export interface ISubPushParams {
  itemIndex: number;
  buyerIndex: number;
  sellerIndex: number;
}

export interface ISubGameState {}

export enum BargainStatus {
  bargain,
  traded,
  left,
}

export interface IBargainBuyerRecord {
  buyerIndex: number;
  status: BargainStatus;
  chat: TChat[];
  tradePrice: number;
  utility: number;
}

export type TChat = Partial<{ role: Role; price: number; msg: string }>;

export type TBargainShopList = {
  sellerIndex: number;
  price: number;
  closed: boolean;
  buyerRecordList: IBargainBuyerRecord[];
}[];

export enum Choice {
  A,
  B,
}

export interface ISubPlayerState {
  inited: boolean;
  nextGameUrl: string;
  answers: TAnswers;
  answerScores: number[];
  result: TResult;
  concept_riskAppetite: Choice[];
  concept_result: {
    i: number;
    choice: Choice;
    endowment: number;
  };
  convenientList: number[];
  salaryList: number[];
  carList: { nameSuffix: number; price: number; discount: number; utility: number }[];
  houseList: {
    price: number;
    deposit: number;
    discount: number;
    utility: number;
  }[];
  insuranceList: { price: number; utility: number }[];
  ticketList: { day: number; airline: number; price: number }[];
  bargain_role: Role;
  index: number;
  bargain_shopList: TBargainShopList;
  tradeIndex: number;
  score: number;
}

export interface IKnowledgePoint {
  namespace: SubNamespace;
  title: string;
  fileName: string;
}

export interface IExtraStat {
  totalVisit: number;
  resultAmount: number;
  schoolAmountList: { name: string; count: number }[];
  teacherAmount: number;
  studentAmount: number;
  avgTime: number;
}

export interface IHomeStat {
  todayVisit: number;
  totalVisit: number;
  resultAmount: number;
}
